const Icon = require('./icons');
export default Icon;
